module.exports = __webpack_public_path__ + "media/images/logos/logo-knowledge-white-5aa7e059e151deb54d691e76398ab78e.svg";